<ng-container
  *ngIf="{
    row: columnData | async
  } as $"
>
  <span>{{$.row?.source? $.row?.source:'Others'}}</span>
</ng-container>
